import { useDispatch, useSelector } from "react-redux";
import { RootState } from "@redux/store"; 
import { addKeywordsAndTopicsSearchKeywords, removeCompanySearchKeywords, removeKeywordsAndTopicsSearchKeywords, saveFiltersState, updateKeywordsAndTopics } from "@redux/slices/filter"; 
import {
  FormControl,
  FormControlLabel,
  Radio,
  RadioGroup,
} from "@mui/material";
import {
  ArrowRight,
  ChevronLeft,
  CircleMinus,
  CirclePlus,
  Minus,
  Plus,
  X,
} from "lucide-react";
import { Button } from "@components/ui/button";
import { useNavigate } from "react-router";
import { IoAdd } from "react-icons/io5";
import { useEffect, useState } from "react";

interface Props {
  handleClose: () => void;
}

const KeywordsAndTopics: React.FC<Props> = ({ handleClose }) => {
  const [searchKeyword, setSearchKeyword] = useState("");

  const navigate = useNavigate();
  const dispatch = useDispatch();

  const keywordsAndTopics = useSelector(
    (state: RootState) => state.filter.companyFilters.keywordsAndTopics
  );
  const searchKeywords = useSelector(
    (state: RootState) =>
      state.filter?.companyFilters?.keywordsAndTopics?.searchKeywords || []
  );
  const data=useSelector((state: RootState)=>state.filter);

  useEffect(() => {
    console.log(keywordsAndTopics);
  }, [keywordsAndTopics]);

  const handleRadioChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const value = event.target.value as "any" | "all";
    dispatch(updateKeywordsAndTopics({ keywordMatch: value }));
    console.log(value, { keywordMatch: value });
  };

  console.log(searchKeywords);

  const handleKeywordAdd = (keyword: string) => {
    console.log(keyword);
    if (!searchKeywords?.includes(keyword)) {
      dispatch(addKeywordsAndTopicsSearchKeywords(keyword));
      setSearchKeyword("");
    }
  };

  const handleKeywordRemove = (keyword: string) => {
    console.log(keyword);
    if (searchKeywords?.includes(keyword)) {
      dispatch(removeKeywordsAndTopicsSearchKeywords(keyword));
    }
  };
  
  const handleSuggestionToggle = (suggestion: string) => {
    console.log(suggestion)
    dispatch(
      updateKeywordsAndTopics({
        suggestions: {
          ...keywordsAndTopics?.suggestions,
          [suggestion]: !keywordsAndTopics?.suggestions[suggestion],
        },
      })
    );
    console.log(keywordsAndTopics);
  };

  const suggestions = keywordsAndTopics.suggestions || {
    Expertise: false,
    Accessories: false,
    Finance: false,
    Training: false,
    Mobile: false,
  };

  return (
    <div className="flex flex-col justify-between h-full p-8">
      <div>
        <div className="flex justify-between items-center mb-5">
          <h4 className="text-xl font-bold flex items-center -ms-2">
            <ChevronLeft
              size={22}
              className="me-3 cursor-pointer"
              onClick={() => navigate(-1)}
            />
            Keywords and Topics
          </h4>
          <X onClick={handleClose} className="cursor-pointer" />
        </div>
        <p className="text-gray font-medium my-3">
          Find companies whose website contain any of the following keywords:
        </p>
        <div className="flex gap-4">
        <div className="w-2/3">
            <div className="relative mb-8">
              <input
                className="appearance-none placeholder:text-[#B5B7C0] placeholder:text-sm placeholder:ps-1 border-0 pl-10 border-[#e2e8f0] bg-white shadow-sm  transition-colors rounded-md w-full py-2 px-3 text-gray-800 leading-tight focus:outline-none"
                id="username"
                type="text"
                placeholder="Search"
                onChange={(e) => setSearchKeyword(e.target.value)}
                value={searchKeyword}
                onKeyDown={(e) => {
                  if (e.key === 'Enter') {
                    handleKeywordAdd(searchKeyword); // Call your function when Enter is pressed
                    setSearchKeyword('');
                   
                  }
                }}
              />

              <div className="absolute left-0 inset-y-0 flex items-center">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  className="h-6 w-6 ml-3 text-gray-400 hover:text-gray-500"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="#71717A"
                >
                  <path
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    stroke-width="2"
                    d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"
                  />
                </svg>
              </div>
              <div className="absolute right-[10px] inset-y-0 flex items-center">
                {/* <Minus className="cursor-pointer me-4" /> */}
                <Plus
                  className="cursor-pointer"
                  onClick={() => handleKeywordAdd(searchKeyword)}
                />
              </div>
            </div>
          <div className="flex items-center gap-4 flex-wrap  overflow-y-scroll h-60">
              {searchKeywords?.map((val: string, index: number) => {
                return (
                  <div className="bg-white p-8 rounded-lg flex justify-between border-b w-1/2 px-4 py-3 mb-2">
                    <p>{val}</p>
                    <X
                      onClick={() => handleKeywordRemove(val)}
                      className="cursor-pointer"
                      size={20}
                    />
                  </div>
                );
              })}
            </div>
          </div>
          <div className="w-1/3">
            <div className="bg-white rounded-lg px-6 py-4">
              <h4 className="text-lg font-bold flex items-center mb-4">
                Keyword Options
              </h4>
              <FormControl>
                <RadioGroup
                  aria-labelledby="keyword-options"
                  value={keywordsAndTopics.keywordMatch}
                  onChange={handleRadioChange}
                  name="keyword-options"
                  className="text-sm"
                >
                  {/* sx={{
                color: '#1CB5AF', // Unchecked color
                '&.Mui-checked': {
                  color: '#1CB5AF', // Checked color
                },
              }} */}
                  <FormControlLabel
                    value="any"
                    control={
                      <Radio
                      sx={{
                        padding: "2px",
                        marginRight: 1,
                        fontSize: 15,
                        color: '#1CB5AF', // Unchecked color
                        '&.Mui-checked': {
                          color: '#1CB5AF', // Checked color
                        },
                      }}
                      />
                    }
                    label="any keyword should match"
                  />
                  <FormControlLabel
                    value="all"
                    control={
                      <Radio
                      sx={{
                        padding: "2px",
                        marginRight: 1,
                        fontSize: 15,
                        color: '#1CB5AF', // Unchecked color
                        '&.Mui-checked': {
                          color: '#1CB5AF', // Checked color
                        },
                      }}
                      />
                    }
                    label="all keywords should match"
                  />
                </RadioGroup>
              </FormControl>
            </div>
            {/* <div className="bg-white rounded-lg px-6 py-4 mt-4">
              <h4 className="text-lg font-bold flex items-center mb-4">
                Suggestion
              </h4>
              {Object?.keys(suggestions)?.map((suggestion) => (
                <div
                  key={suggestion}
                  className={`flex items-end justify-between border-[1px] border-x-0 border-t-0 border-[#DBDBDB] ${
                    suggestions[suggestion] ? "pt-2 pb-1" : "pb-1 pt-2"
                  } text-sm font-medium cursor-pointer text-[#71717A]`}
                  onClick={() => handleSuggestionToggle(suggestion)}
                >
                  <h6 className="ms-1">{suggestion}</h6>
                  <div className="flex">
                  <CircleMinus
                      size={18}
                      className={`${
                        suggestions[suggestion]
                          ? "text-slate-400"
                          : "text-black rounded-full"
                      }`}
                    />
                    <CirclePlus
                      size={18}
                      className={`${
                        suggestions[suggestion]
                          ? "text-black rounded-full"
                          : "text-slate-400"
                      } ms-1`}
                    />
                  </div>
                </div>
              ))}
            </div> */}
          </div>
        </div>
      </div>
      <div className="flex justify-end">
        <Button onClick={() => navigate(-1)} className="bg-[#1CB5AF]">Save</Button>
      </div>
    </div>
  );
};

export default KeywordsAndTopics;
